// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__PvoPM","Success":"Button_Success__3r3E-","Danger":"Button_Danger__2qRAp"};